import type { RowData } from '@tanstack/react-table';
import type { Column } from '../appTable';
import { DatePickerRangeFilter } from './DatePickerRangeFilter';
import { MultiSearchFilter } from './MultiSearchFilter';
import { MultiSelectFilter } from './MultiSelectFilter';
import { SingleSearchFilter } from './SingleSearchFilter';
import { SingleSelectFilter } from './SingleSelectFilter';

export const getColumnFilter = <T extends RowData>(column: Column<T>) => {
  if (!column.getCanFilter() || !column.columnDef.meta?.filterVariant) return null;

  switch (column.columnDef.meta?.filterVariant.type) {
    case 'dateRange':
      return <DatePickerRangeFilter column={column} />;
    case 'multiSearch':
      return <MultiSearchFilter column={column} />;
    case 'singleSearch':
      return <SingleSearchFilter column={column} />;
    case 'singleSelect':
      return <SingleSelectFilter column={column} />;
    case 'multiSelect':
      return <MultiSelectFilter column={column} />;
  }
};
